const styles = () => ({
  root: {
    flex: '1 1 auto',
    display: 'flex',
    minHeight: 0,
    flexDirection: 'column',
    padding: '35px 0',
  },

  noPadding: {
    padding: 0,
  },
});

export default styles;
